<div class="cardBloque ">
    <h1 style="text-align: center; color: black; font-weight: bolder;" class="titlesSize">BENEFICIOS</h1>
   

    <div class="row" *ngIf="this.Benefits.length > 0 ">
            <div class="col-md-3" *ngFor="let bene of paginatedBenefits">
                <ng-container *ngIf="bene.link">
                    <div class="card colorLandingCard" (click)="redirectInmoapp()" style="cursor: pointer;">
                        <div class="card-body">
                            <div class="containTextBenTitle">
                                <h2 class="text-center text-primary">{{bene.title}}</h2>
                            </div>
                            <img class="img-responsiva  img-fluid " [src]="url + bene.image" alt="banner">
                            <div class="containTextBen">
                                <p class="card-text mt-2 ">
                                    {{bene.description}}
                                </p>
                            </div>

                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!bene.link">
                    <div class="card colorLandingCard">
                        <div class="card-body">
                            <div class="containTextBenTitle">
                                <h2 class="text-center text-primary">{{bene.title}}</h2>
                            </div>
                            <div *ngIf="bene.category_name" class="text-center">
                                <span class="badge badge-pill badge-primary">{{bene.category_name}} </span>
                            </div>
                            <img class="img-responsiva  img-fluid " [src]="url + bene.image" alt="banner">
                            <div class="containTextBen">
                                <p class="card-text mt-2 ">
                                    {{bene.description}}
                                </p>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>
    </div>
    <div class="row">
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">Anterior</button>
        </div>
        <div class="col-md-6 text-center">
            <button class="btn btn-primary" (click)="goToPage(currentPage + 1)"
                [disabled]="currentPage * pageSize >= Benefits.length">Siguiente</button>
        </div>
    </div>

    <div class="text-center">
        <a href="/beneficios" class="btn btn-primary">+</a>
    </div>
</div>